var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getBusinessPermission || _vm.userType == "super_admin"
    ? _c("div", { staticClass: "setting-main-container" }, [
        _c("div", { staticClass: "card setting-card" }, [
          _c("div", { staticClass: "page-header" }, [
            _c("h3", { staticClass: "page-title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "profile.financial_institutions.financial_institutions"
                  )
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6 mb-4" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(
                  _vm._s(_vm.$tc("profile.financial_institutions.imports"))
                ),
              ]),
              _vm._v(" "),
              _vm.business && _vm.business.imports != null
                ? _c("p", [_vm._v(_vm._s(_vm.business.imports))])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-4" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(
                  _vm._s(_vm.$tc("profile.financial_institutions.exports"))
                ),
              ]),
              _vm._v(" "),
              _vm.business && _vm.business.exports != null
                ? _c("p", [_vm._v(_vm._s(_vm.business.exports))])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-12 mb-4" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(
                  _vm._s(
                    _vm.$tc("profile.financial_institutions.remittances_effect")
                  )
                ),
              ]),
              _vm._v(" "),
              _vm.business && _vm.business.remittances_effected != null
                ? _c("p", [_vm._v(_vm._s(_vm.business.remittances_effected))])
                : _vm._e(),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }